<h1 mat-dialog-title class="cls-modal-block-title">
    <div class="cls-icon-krest1">
        <mat-icon svgIcon="krest" [mat-dialog-close]="true"></mat-icon>
    </div>

    <!--
  <span class="cls-modal-block-header">Описание посещения пациента</span>
--></h1>

<div mat-dialog-content>
    <div [innerHTML]="resHtml"></div>
    <div *ngIf="link" class="result_pdf">
        Просмотреть
        <button
            class="result-item"
            (click)="gotToDownload(link, $event)"
        >
            <img
                *ngIf="!pdfLoading"
                class="result-item__img"
                [src]="pdfImageURL"
            />
            <img
                *ngIf="pdfLoading"
                class="loader-rotate"
                src="./assets/img/svg/loader-btn.svg"
            />
        </button>
    </div>
    <div class="btn_close">
        <button class="btn btn-dialog-close" [mat-dialog-close]="true">
            Закрыть
        </button>
    </div>
</div>
